import {Injectable} from '@angular/core';
import {LocationDetailDto} from '../../features/startup/dtos/location-detail.dto';

@Injectable({
  providedIn: 'root'
})
export class MemoryService {
  patientDataInitialized = false;
  bookingDataInitialized = false;

  accessToken?: string;
  isNewUser?: boolean;
  locationDetailDto?: LocationDetailDto;

  private _refreshToken?: string;

  get refreshToken(): string | undefined {
    if (!this._refreshToken) {
      this._refreshToken = localStorage.getItem('refreshToken') ?? undefined;
    }

    return this._refreshToken;
  }

  set refreshToken(value: string | undefined) {
    if (value === undefined) {
      this._refreshToken = undefined;
      localStorage.removeItem('refreshToken');
      return;
    }
    this._refreshToken = value;
    localStorage.setItem('refreshToken', value);
  }

  private _isPatientManager?: boolean;

  get isPatientManager(): boolean | undefined {
    if (!this._isPatientManager) {
      this._isPatientManager = sessionStorage.getItem('isPatientManager') === 'true';
    }

    return this._isPatientManager;
  }

  set isPatientManager(value: boolean | undefined) {
    if (value === undefined) {
      this._isPatientManager = undefined;
      sessionStorage.removeItem('isPatientManager');
      return;
    }

    this._isPatientManager = value;
    sessionStorage.setItem('isPatientManager', value.toString());
  }

  private _patientId?: number;

  get patientId(): number | undefined {
    if (!this._patientId) {
      const patientIdString = localStorage.getItem('patientId');
      this._patientId = patientIdString ? parseInt(patientIdString) : undefined;
    }

    return this._patientId;
  }

  set patientId(value: number | undefined) {
    if (value === undefined) {
      this._patientId = undefined;
      localStorage.removeItem('patientId');
      return;
    }
    this._patientId = value;
    localStorage.setItem('patientId', value.toString());
  }

  private _patientEmail?: string;

  get patientEmail(): string | undefined {
    if (!this._patientEmail) {
      this._patientEmail = localStorage.getItem('patientMail') ?? undefined;
    }

    return this._patientEmail;
  }

  set patientEmail(value: string | undefined) {
    if (value === undefined) {
      this._patientEmail = undefined;
      localStorage.removeItem('patientMail');
      return;
    }
    this._patientEmail = value;
    localStorage.setItem('patientMail', value);
  }

  private _customerId?: number;

  get customerId(): number | undefined {
    if (!this._customerId) {
      const customerIdString = sessionStorage.getItem('customerId');
      this._customerId = customerIdString ? parseInt(customerIdString) : undefined;
    }

    return this._customerId;
  }

  set customerId(value: number | undefined) {
    if (value === undefined) {
      this._customerId = undefined;
      sessionStorage.removeItem('customerId');
      return;
    }
    this._customerId = value;
    sessionStorage.setItem('customerId', value.toString());
  }

  private _locationId?: number;

  get locationId(): number | undefined {
    if (!this._locationId) {
      const locationIdString = sessionStorage.getItem('locationId');
      this._locationId = locationIdString ? parseInt(locationIdString) : undefined;
    }

    return this._locationId;
  }

  set locationId(value: number | undefined) {
    if (value === undefined) {
      this._locationId = undefined;
      sessionStorage.removeItem('locationId');
      return;
    }
    this._locationId = value;
    sessionStorage.setItem('locationId', value.toString());
  }

  private _categoryId?: number;

  get categoryId(): number | undefined {
    if (!this._categoryId) {
      const categoryIdString = sessionStorage.getItem('categoryId');
      this._categoryId = categoryIdString ? parseInt(categoryIdString) : undefined;
    }

    return this._categoryId;
  }

  set categoryId(value: number | undefined) {
    if (value === undefined) {
      this._categoryId = undefined;
      sessionStorage.removeItem('categoryId');
      return;
    }
    this._categoryId = value;
    sessionStorage.setItem('categoryId', value.toString());
  }

  private _employeeId?: number;

  get employeeId(): number | undefined {
    if (!this._employeeId) {
      const employeeIdString = sessionStorage.getItem('employeeId');
      this._employeeId = employeeIdString ? parseInt(employeeIdString) : undefined;
    }

    return this._employeeId;
  }

  set employeeId(value: number | undefined) {
    if (value === undefined) {
      this._employeeId = undefined;
      sessionStorage.removeItem('employeeId');
      return;
    }
    this._employeeId = value;
    sessionStorage.setItem('employeeId', value.toString());
  }

  private _categoryGroup?: string;

  get categoryGroup(): string | undefined {
    if (!this._categoryGroup) {
      this._categoryGroup = sessionStorage.getItem('categoryGroup') ?? undefined;
    }

    return this._categoryGroup;
  }

  set categoryGroup(value: string | undefined) {
    if (value === undefined) {
      this._categoryGroup = undefined;
      sessionStorage.removeItem('categoryGroup');
      return;
    }
    this._categoryGroup = value;
    sessionStorage.setItem('categoryGroup', value);
  }

  private _gtmOrigin?: string;

  get gtmOrigin(): string | undefined {
    if (!this._gtmOrigin) {
      this._gtmOrigin = sessionStorage.getItem('gtmOrigin') ?? undefined;
    }

    return this._gtmOrigin;
  }

  set gtmOrigin(value: string | undefined) {
    if (value === undefined) {
      this._gtmOrigin = undefined;
      sessionStorage.removeItem('gtmOrigin');
      return;
    }

    this._gtmOrigin = value;
    sessionStorage.setItem('gtmOrigin', value);
  }
}
